<template>
    <div class="company" v-loading="loading">
        <div class="have-company" v-if="userInfo.companyId">
            <div class="company-name">{{userInfo.companyName}}</div>
            <div class="info">
                <div class="form-group">
                    <label>姓名</label>
                    <el-input v-model="name" placeholder="我在团队中姓名"></el-input>
                </div>
                <div class="form-group">
                    <label>电话号</label>
                    <el-input v-model="userInfo.mobile" disabled></el-input>
                </div>
            </div>
            <div class="foot">
                <button @click="saveName">保存</button>
                <button @click="quitCompany" v-if="!userInfo.leader">退出该企业</button>
            </div>
        </div>
        <div class="no-company" v-else>
            <div class="no-data">
                <img src="@/assets/img/user/company_none.png" />暂未加入企业团队
            </div>
            <div class="code">
                <input type="text" placeholder="输入专属邀请码，加入企业团队享福利" v-model="code">
                <button @click="joinCompany">立即加入</button>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import { mapGetters } from "vuex";
export default {
    components: {},
    data() {
        return {
            code: '',
            name: '',
            loading: false
        };
    },
    computed: {
        ...mapGetters({userInfo: "getUser"})
    },
    mounted(){
        this.name=this.userInfo.name
    },
    methods: {
        saveName() {
            this.loading = true;
            this.$http.post("/app/updateName", qs.stringify({ name: this.name })).then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.userInfo.name = this.name;
                    this.$store.commit("setUser", this.userInfo);
                    this.$message.success('姓名修改成功！')
                }
            })
        },
        quitCompany() {
            this.$confirm('是否确认退出该企业?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                this.$http.post("/app/company/delGroupPerson", qs.stringify({ groupId: this.userInfo.companyId, userId: this.userInfo.userId })).then(res => {
                    if (res.data.code == 0) {
                        this.getUserInfo();
                        this.$message.success('已退出该企业！');
                    }
                })
            }).catch(() => { });
        },
        joinCompany() {
            if (this.code.trim()) {
                this.loading = true;
                this.$http.post("/app/company/joinGroup", qs.stringify({ code: this.code.trim() })).then(res => {
                    this.loading=false;
                    if (res.data.code == 0) {
                        this.$message.success('成功加入企业！');
                        this.code = '';
                        this.getUserInfo();
                    }
                })
            } else {
                this.$message.error('请输入专属邀请码！')
            }
        },
        getUserInfo() {
            this.$http.post("app/userInfo").then(res => {
                this.loading = false;
                if (res.data.code == 0) {
                    this.userInfo = res.data.data;
                    this.$store.commit("setUser", res.data.data);
                }
            });
        }
    },
}
</script>

<style lang="less" scoped>
.company {
    background-color: #fff;
    padding: 20px;
    .have-company {
        .company-name {
            line-height: 55px;
            font-size: 16px;
            font-weight: bold;
            padding-left: 56px;
            background: #f3f7ff url("../../assets/img/user/company_icon.png")
                27px 17px no-repeat;
            margin-bottom: 20px;
        }
        .info {
            width: 260px;
            font-size: 14px;
            .form-group {
                margin-bottom: 18px;
                label {
                    display: block;
                    margin-bottom: 6px;
                }
            }
        }
        .foot {
            border-top: #eee 1px solid;
            padding-top: 20px;
            text-align: right;
            button {
                width: 126px;
                height: 36px;
                font-size: 14px;
                color: #666;
                border: #ccc 1px solid;
                margin-left: 20px;
                &:first-child {
                    border-color: #3779ff;
                    color: #3779ff;
                }
            }
        }
    }
    .no-company {
        padding-bottom: 60px;
        .code {
            margin-top: -50px;
            text-align: center;
            input {
                vertical-align: middle;
                height: 40px;
                width: 300px;
                border: #eee 1px solid;
                background-color: #f5f5f5;
                padding: 0 20px;
                &::placeholder {
                    color: #ccc;
                }
            }
            button {
                vertical-align: middle;
                width: 100px;
                height: 42px;
                font-size: 14px;
                color: #fff;
                border: #3779ff 1px solid;
                background-color: #3779ff;
            }
        }
    }
}
/deep/.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #333;
}
/deep/.el-input__inner {
    border-radius: 0;
}
</style>
